import React, { useEffect } from 'react';
import {
    Grid, Menu, Breadcrumb, Tab, Label, Icon,
    Loader
} from 'semantic-ui-react'
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import Feicon from './Feicon.js';

import Relatorio from './Relatorio.js';
import { WhatsappVendedoresListAction, GetVendedoresRelatorioAction } from '../../actions/WhatsappActions.js';
import ContatosParc from './ContatosParc.js';

function Whatsapp(props) {


    const { vendedoresList, WhatsappVendedoresListAction, userid, parceirosLoader, GetVendedoresRelatorioAction, codvend, GetVendedoresRelatorio, vendedoresRelatorio, vendedoresRelatorioLoader, tipvend } = props;

    useEffect(() => {
        if (vendedoresList != null) {
            WhatsappVendedoresListAction(userid)
            console.log(WhatsappVendedoresListAction(userid));
            
        }
    }, []);

    


    useEffect(() => {
        //if (props.active) {
        console.log("Chamando API com codvend:", codvend);
        console.log("Tipo do codvend:", typeof codvend);
        console.log("É null?", codvend === null);
        console.log("É undefined?", codvend === undefined);
        GetVendedoresRelatorioAction({ codvend: codvend });
        //}
    }, []);

    // if (parceirosLoader) {
    //     return (
    //         <div style={{ padding: '2em', textAlign: 'center' }}>
    //             <Loader active inline="centered" size="large">
    //                 Carregando vendedores...
    //             </Loader>
    //         </div>
    //     );
    // }

    let panes = [

        {
            menuItem: <Menu.Item key='TABfuncnova'><Icon name='whatsapp' />Contatos Parceiros</Menu.Item>,
            render: () => <ContatosParc />,

        },
        {
            menuItem: <Menu.Item key='TABpendente'><Icon name='chart bar outline' />FEICON</Menu.Item>,
            render: () =>
                <Feicon />,
        }
    ]

    //inverter a ordem do fluxo, ao invés de ser diferente de V, começa com display none e se for diferente aplica o display block

    console.log("tipvend: ", tipvend);
    

    if (tipvend !== 'V'  ) {
        panes.push({
            menuItem: <Menu.Item 
                key='TABpendente'
                
            ><Icon name='chart bar outline' />Relatório</Menu.Item>,
            render: () =>
                <Relatorio />,
        }
        )
    }




    return (
        <div style={{ padding: '1em 0' }}>
            <Menu stackable size='mini' style={{ background: 'transparent', border: 'none', borderBottom: 'solid 1.5px #1884af', boxShadow: 'none', borderRadius: '0 0 5px 5px' }}>
                <Menu.Item>
                    <Breadcrumb size='mini'>
                        <Breadcrumb.Section href="/Home">Home</Breadcrumb.Section>
                        <Breadcrumb.Divider icon='right chevron' />
                        <Breadcrumb.Section active>Whatsapp</Breadcrumb.Section>
                    </Breadcrumb>
                </Menu.Item>
            </Menu>
            <div>
                <Grid columns={1} doubling loading={parceirosLoader}>
                    <Grid.Column >
                        <Tab panes={panes} />
                    </Grid.Column>
                </Grid>
            </div>

            <style>{`

                /*-------------------------------*/
                /*Menu Superior*/


                .ui.mini.menu>.item{
                    padding: 0;
                }

                .ui.breadcrumb .section {
                    padding: 1.5em 1.5em !important;
                }
                
                .ui.breadcrumb .section:first-child {
                    padding-right: 0 !important;
                    border-radius: 0 0 0 5px !important;
                }
                    

                .ui.breadcrumb .active.section {
                    background-color: #1884af !important;
                    color: #fff !important;
                }
            `}</style>

        </div>
    );
}

const mapStateToProps = (state) => ({
    userid: state.LoginReducer.userid,
    tipvend: state.LoginReducer.tipvend,
    codvend: state.LoginReducer.vendedorvcc,
    vendedoresList: state.WhatsappReducer.vendedoresList,
    parceirosLoader: state.WhatsappReducer.parceirosLoader,

    
    vendedoresRelatorio: state.WhatsappReducer.vendedoresRelatorio,
    vendedoresRelatorioLoader: state.WhatsappReducer.vendedoresRelatorioLoader

})

// export default Whatsapp;

export default withRouter(connect(mapStateToProps, {
    WhatsappVendedoresListAction,
    GetVendedoresRelatorioAction
}
)(Whatsapp));
